
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.653 3.21l-1.906-2A1.213 1.213 0 008.88.85H3.547a1.22 1.22 0 00-1.214 1.2v1.114H1.22A1.22 1.22 0 000 4.384v9.56a1.22 1.22 0 001.22 1.22h7.227a1.22 1.22 0 001.22-1.22V12.83h1.113A1.22 1.22 0 0012 11.61V4.057a1.2 1.2 0 00-.347-.847zM8 13.83H1.667a.333.333 0 01-.334-.333V4.83a.333.333 0 01.334-.333h.5a.167.167 0 01.166.167v6.946a1.22 1.22 0 001.22 1.22h4.614a.167.167 0 01.166.167v.5A.333.333 0 018 13.83zm2.333-2.333H4a.333.333 0 01-.333-.333V2.497A.333.333 0 014 2.164h4.667a.347.347 0 01.246.106l1.66 1.727a.321.321 0 01.094.227v6.94a.333.333 0 01-.334.333z","fill":"#161616","fill-opacity":".64"}})])
          )
        }
      }
    